var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.navigationBarType)?_c('div',{attrs:{"id":"app"}},[_c('navigationBar',{attrs:{"menuArr":_vm.menuArr}}),_vm._v(" "),_c('navigationBarLeft',{attrs:{"menuLeftArr":_vm.menuLeftArr,"activeIndex":_vm.activeIndex}}),_vm._v(" "),_c('div',{staticClass:"main"},[_c('router-view')],1)],1):_c('div',{attrs:{"id":"appNo"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fdcfedd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 